<div class="flex space-x-2 items-center">
  @for (option of colorOptions(); track option.value) {
    <div
      class="rounded-full w-6 h-6 cursor-pointer border-2"
      [style.backgroundColor]="option.color"
      [class.border-transparent]="option.value === value"
      [class.border-smoke]="option.value !== value"
      [class.ring-1]="option.value === value"
      [class.ring-black]="option.value === value"
      [class.ring-offset-2]="option.value === value"
      (click)="selectColor(option.value)"
      tabindex="0"
      role="button"
      [attr.aria-pressed]="option.value === value"></div>
  }
</div>
